import styled from "@emotion/styled";

export const MapperSettingsContainer = styled.div`
  display: flex;
  justify-content: space-around;
  max-width: 100%;
  margin: 0 2rem;
  z-index: 1;
  overflow: auto;
`;
